import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TeamInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /*if (request.url.includes('extranet.tenaris')) {
      const shouldAddTokenIssuer = !(request.url.includes('login.extranet.tenaris.com'));
      const teamToken = JSON.parse(sessionStorage.getItem('team-token'));
      console.log('TeamInterceptor - teamToken:', teamToken);
      request = request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          ...(shouldAddTokenIssuer && { 'X-Token-Issuer': 'TEAM' }),
          ...(teamToken && teamToken.access_token) && { 'Authorization': `Bearer ${teamToken.access_token}` }
        })
      });

    }*/
    return next.handle(request);
  }
}
